import { Controller } from "@hotwired/stimulus"

// Real-time CPF validation with visual feedback
export default class extends Controller {
  static targets = ["input", "feedback", "message"]
  static values = {
    required: { type: Boolean, default: false }
  }

  connect() {
    this.validate()
  }

  validate() {
    const cpf = this.inputTarget.value.replace(/\D/g, '')

    // Empty field
    if (cpf.length === 0) {
      this.showNeutral()
      return
    }

    // Incomplete CPF
    if (cpf.length < 11) {
      this.showIncomplete(cpf.length)
      return
    }

    // Validate CPF
    if (this.isValidCPF(cpf)) {
      this.showValid()
    } else {
      this.showInvalid()
    }
  }

  isValidCPF(cpf) {
    // Check for known invalid patterns
    if (/^(\d)\1{10}$/.test(cpf)) return false

    // Validate first digit
    let sum = 0
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let remainder = (sum * 10) % 11
    if (remainder === 10 || remainder === 11) remainder = 0
    if (remainder !== parseInt(cpf.charAt(9))) return false

    // Validate second digit
    sum = 0
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i)
    }
    remainder = (sum * 10) % 11
    if (remainder === 10 || remainder === 11) remainder = 0
    if (remainder !== parseInt(cpf.charAt(10))) return false

    return true
  }

  showNeutral() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.innerHTML = ''
      this.feedbackTarget.className = 'absolute right-3 top-1/2 -translate-y-1/2'
    }
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = ''
      this.messageTarget.className = 'hidden'
    }
    this.inputTarget.classList.remove('border-red-500', 'border-green-500', 'focus:ring-red-500', 'focus:ring-green-500')
  }

  showIncomplete(length) {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.innerHTML = `<span class="text-xs text-gray-400">${length}/11</span>`
      this.feedbackTarget.className = 'absolute right-3 top-1/2 -translate-y-1/2'
    }
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = ''
      this.messageTarget.className = 'hidden'
    }
    this.inputTarget.classList.remove('border-red-500', 'border-green-500', 'focus:ring-red-500', 'focus:ring-green-500')
  }

  showValid() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.innerHTML = `
        <svg class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
        </svg>
      `
    }
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = 'CPF válido'
      this.messageTarget.className = 'text-xs text-green-600 mt-1'
    }
    this.inputTarget.classList.remove('border-red-500', 'focus:ring-red-500')
    this.inputTarget.classList.add('border-green-500', 'focus:ring-green-500')
  }

  showInvalid() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.innerHTML = `
        <svg class="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
      `
    }
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = 'CPF inválido'
      this.messageTarget.className = 'text-xs text-red-600 mt-1'
    }
    this.inputTarget.classList.remove('border-green-500', 'focus:ring-green-500')
    this.inputTarget.classList.add('border-red-500', 'focus:ring-red-500')
  }
}
